import { oz } from '@weft/utils';

export const FILTER_OPERATORS = Object.freeze({
  equals: 'equals',
  notEquals: 'notEquals',
  contains: 'contains',
  notContains: 'notContains',
  startsWith: 'startsWith',
  endsWith: 'endsWith',
  greaterThan: 'greaterThan',
  greaterThanOrEquals: 'greaterThanOrEquals',
  lessThan: 'lessThan',
  lessThanOrEquals: 'lessThanOrEquals',
  isNull: 'isNull',
  isNotNull: 'isNotNull',
});

export const FilterOperatorsSchema = oz.nativeEnum(FILTER_OPERATORS);

export type FilterOperator = oz.infer<typeof FilterOperatorsSchema>;